import React, { Component } from "react";
// import { connect } from "react-redux";
// import { bindActionCreators } from "redux";
// import * as prismicActions from "../redux/actions/prismicActions";
// import PrismicReact from "prismic-reactjs";
import PropTypes from "prop-types";
import { Form, Input, Button, Label } from "reactstrap";
// import jsonp from "jsonp";
import axios from 'axios'

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      name: "",
      message: "",
      error: false,
      success: false,
      disabled: true
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
      error: false,
      success: false
    });

    if(this.valEmail(this.state.email) && this.state.message && this.state.name) {
      this.setState({disabled: false})
    } else if(!this.state.message || !this.state.name) {
      this.setState({disabled: true})
    }
  }

  handleSubmit(event) {
    console.log(event);
    this.validateEmail(this.state.email);
    event.preventDefault();
  }

  validateEmail(email) {
    console.log('validateEmail: ', email);
    // Email RegEx in config/formValidation
    if (this.valEmail(email)) {

      const formFields = {
        name: this.state.name,
        email: this.state.email,
        message: this.state.message
      }
  
      // axios plugin
      axios.post(
        'https://e26fcmxo7l.execute-api.ca-central-1.amazonaws.com/mail',
        { formFields }
      ).then(res => {
        console.log(res)
        console.log(res.data)
        this.setState({
          success: true,
          error: false
        });
      }).catch(error => {
        console.log(error)
        this.setState({
          error: true,
          success: false
        });
      })
      
      // Submit email to Mailchimp
      // var sendToMailchimp = email => {
      //   var mailchimpURL =
      //     "https://auroramj.us10.list-manage.com/subscribe/post-json?u=" +
      //     this.props.mailchimpListU +
      //     "&amp;id=" +
      //     this.props.mailchimpListId +
      //     "&subscribe=Subscribe&EMAIL=" +
      //     email +
      //     "&NAME=" +
      //     this.state.name +
      //     "&MESSAGE=" + this.state.message

      //   jsonp(
      //     mailchimpURL,
      //     {
      //       param: "c"
      //     },
      //     (err, data) => {
      //       if (err) {
      //         this.setState({
      //           error: true,
      //           success: false
      //         });
      //       } else {
      //         this.setState({
      //           success: true,
      //           error: false
      //         });
      //       }
      //     }
      //   );
      // };
      // sendToMailchimp(email);
    } else {
      this.setState({
        error: true,
        success: false
      });
    }
  }

  // Validate email
  valEmail(userEmail) {
    let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let isEmailValid = emailRegex.test(userEmail);

    if (!isEmailValid) {
      this.setState({
        error: true,
        disabled: true
      });
    }

    return isEmailValid;
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit} noValidate className="newsletter">
        <Input
          type="text"
          name="name"
          placeholder={this.props.namePlaceholder ? this.props.namePlaceholder : "Name"}
          value={this.state.name}
          onChange={this.handleChange}
          className="form-fields"
        />
        <Input
          type="email"
          name="email"
          placeholder={this.props.emailPlaceholder ? this.props.emailPlaceholder : "Email"}
          value={this.state.email}
          onChange={this.handleChange}
          className={`form-fields input-email ${this.state.error ? 'error' : ''}`}
        />
        <div className={`${this.state.error ? "show-validation-message error-message" : "validation-message"}`}>
          {this.props.errorMessage}
        </div>
        <Input 
          type="textarea" 
          name="message" 
          id="exampleText" 
          placeholder={this.props.textAreaPlaceholder ? this.props.textAreaPlaceholder : "Enter message here:"}
          value={this.state.message}
          onChange={this.handleChange}
          className="form-fields"
        />
        <Button
          type="submit"
          className="newsletter-button"
          // disabled={this.state.disabled}
        >
          {this.props.subscribeBtnText ? this.props.subscribeBtnText : "Subscribe"}
        </Button>
        <div className={`${this.state.success ? "show-validation-message success-message" : "validation-message"}`}>
          {this.props.successMessage}
        </div>
      </Form>
    );
  }
}

ContactForm.propTypes = {
  sectionContent: PropTypes.object,
  linkResolver: PropTypes.func
};

export default ContactForm;






// WEBPACK FOOTER //
// ./src/components/ContactForm.js